@if (selfElement$ | async; as selfElement) {
	<stages-process-element-properties
		[translateNone]="translateNone"
		[propertyList]="propertyList"
		[currentElement]="$any(selfElement)"
	/>
}
